<template>
    <framed-layout>

        <template #center>
            <h3 class="font-bold">Hinnapäring esitatud</h3>
        </template>

        <template #right>
            <router-link to="/projects" class="btn-circle">
                <i class="text-xl text-blue-500 pi pi-times"></i>
            </router-link>
        </template>

        <div class="max-w-screen-md mx-auto">
            <h1 class="text-xl font-bold leading-tight text-center md:text-4xl">
                Projekti lähteülesanne on saadetud projekteerijatele hindamiseks
            </h1>

            <img src="/images/happy_mail.svg" class="mx-auto my-16" />

            <div v-if="false" class="my-10 text-center md:text-lg">
                Saatsime sulle kinnitus e-maili <strong>{{ user.email }}</strong>
            </div>
        </div>
    </framed-layout>
</template>

<script>
import FramedLayout from './../../Layouts/FramedLayout'
import { mapGetters } from 'vuex';

export default {
    components: {
        FramedLayout
    },
    data() {
        return {
            //
        }
    },
    computed: {
        ...mapGetters({
            user: 'global/user',
            isAdmin: 'global/isAdmin',
        }),
    },
    methods: {
        //
    }
}
</script>

<style scoped lang="scss">
::v-deep .p-listbox {
    //
}
</style>
